import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import CardsImage from 'assets/images/it-management-cards-banner.png'
import ManualPaymentsImage from 'assets/images/it-management-manual-payments.png'

import i18n from 'modules/core/lib/i18n'

type Props = {
  onClickCta: () => void
  ctaTitle?: string
}

const PaymentsBlock = ({ onClickCta, ctaTitle }: Props) => {
  return (
    <Box width="full" alignItems="center" paddingX="s64" paddingY="s32" gap="s48">
      <Box gap="s8" maxWidth="s600" textAlign="center">
        <Text weight="semibold" size="500" color="grey1000">
          {i18n.t('it_management.initial_setup.payments_block.title')}
        </Text>
        <Text.Normal weight="medium">
          {i18n.t('it_management.initial_setup.payments_block.description')}
        </Text.Normal>
      </Box>

      <Box flexDirection="row" width="full" gap="s24" justifyContent="center">
        <Box
          gap="s32"
          padding="s24"
          maxWidth="s600"
          boxShadow="s200"
          borderRadius={{ all: 'abs008' }}
        >
          <Box gap="s8" paddingX="s48" textAlign="center">
            <Text weight="semibold" size="400" color="grey1000">
              {i18n.t('it_management.initial_setup.payments_block.cards.title')}
            </Text>
            <Text.Normal>
              {i18n.t('it_management.initial_setup.payments_block.cards.description')}
            </Text.Normal>
          </Box>
          <Box paddingTop="s24" alignItems="center">
            <Box width="s300">
              <img width="100%" src={CardsImage} />
            </Box>
          </Box>
        </Box>

        <Box
          gap="s32"
          padding="s24"
          maxWidth="s600"
          boxShadow="s200"
          borderRadius={{ all: 'abs008' }}
        >
          <Box gap="s8" paddingX="s48" textAlign="center">
            <Text weight="semibold" size="400" color="grey1000">
              {i18n.t('it_management.initial_setup.payments_block.manual.title')}
            </Text>
            <Text.Normal>
              {i18n.t('it_management.initial_setup.payments_block.manual.description')}
            </Text.Normal>
          </Box>
          <Box alignItems="center" paddingLeft="s32">
            <Box width="s300">
              <img width="100%" src={ManualPaymentsImage} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Button onClick={onClickCta}>
        {ctaTitle || i18n.t('it_management.initial_setup.get_started_block.cta')}
      </Button>
    </Box>
  )
}

export default PaymentsBlock
